import Sidemenu from "../../layout/sidemenu";
import Header from "../../layout/header";
import { Tooltip } from 'react-tooltip';
import { useNavigate } from "react-router";
import { useState,useEffect } from "react";
import { NoAuthApiRequest,ApiRequest } from "../services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../../utils/endpoints";
import { setIn } from "formik";
import AssignUser from "../assign-user";
import React, { useRef } from 'react';
import  Loader from '../shared/loader';
import { toast } from "react-toastify";

const ProjectUsers  = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [loader,setloader]=useState(false);
    const [lstProjects, setlstProjects] = useState([]);
    const navigate = useNavigate();
    const [Index,setIndex]=useState(-1);
    const [projectName,setprojectName]=useState('');
    const [users, setUsers] = useState([]);
    const [userstype,setuserstype]=useState([]);
    const [search,setsearch]=useState('');
    const [assignUsers, setAssignUsers] = useState([]);
    const [searchalluser,setsearchalluser]=useState('');
    const [searchassigneduser,setsearchassigneduser]=useState('');

    const filteredUsers = users.filter(user => user.Name.toLowerCase().includes(searchalluser.toLowerCase()));
    const filteredAssignedUsers = assignUsers.filter(user => user.Name.toLowerCase().includes(searchassigneduser.toLowerCase()));

    // const [state, setstate] = useState(
    //     items: [],
    //     selected: getItems(5, 5)
    //     );

    // const state = {
    //     items: users,
    //     selected: assignUsers
    // };
    // const [users, setUsers] = useState(
    //     [
    //         { id: '4', name: 'Vinothkumar' },
    //         { id: '5', name: 'Manikandan' }
    //     ]
    // );

    // const [assignUsers, setAssignUsers] = useState([
    //     { id: '1', name: 'Preethi R' },
    //     { id: '2', name: 'Harini Swamy' },
    //     { id: '3', name: 'Madhumitha R' },
    // ]);

      useEffect(() => {
        
                const fetchData = async () => {
                   await fetchProjectList();
                };
                fetchData();
        
            },[]);

            const handleKeyPress = async (event) => {
                // Check if the pressed key is Enter (keyCode 13)
                if (event.key === 'Enter') {
                    await fetchProjectList();
                  // You can trigger any logic here when Enter is pressed
                }
              };
            
              const handleChanges = (event) => {
                setsearch(event.target.value);
              };

    const fetchProjectList = async()=>{

        setloader(true);
            const data = await ApiRequest(ApiEndpoints.Entity.FetchProjectWithParams("ProjectUserMapping",search), ApiEndpointMethod.Get, null, navigate);
                if(data != null){
                    setlstProjects(data);
                    setIndex(-1);
                    if(data.length>0){
                //     setIndex(0);
                //     setprojectName(data[0].Name);
                //    await FetchProjectUserMapping(data[0].Id)
                    }
                }
                setloader(false);
    }

    const FetchProjectUserMapping = async(ProjectId)=>{
        setloader(true);
        const data = await ApiRequest(ApiEndpoints.Entity.FetchProjectMapping(ProjectId), ApiEndpointMethod.Post, null, navigate);
        if(data != null){
        
            setUsers(data.Item1)
            setAssignUsers(data.Item2);
        }
        setloader(false);
    }

    const moveValue = async(Id,type)=>{
      
        if(type=="User"){
        var filtervalue =  users.filter(x=>x.Id==Id);
        if(filtervalue != null && filtervalue.length>0){
            var lstusers=[];
            lstusers = users.filter(x=>x.Id!=Id);
            // users.forEach((item) => {
            //     lstusers.push(item);
            // });
            
            // filtervalue.forEach((item) => {
            //     lstusers.pop(item);
            // });
          
            lstusers.sort((a, b) => a.Name.localeCompare(b.Name));
            setUsers(lstusers);

            var lstassignoption =[];
            assignUsers.forEach((item) => {
                lstassignoption.push(item);
            });
            filtervalue.forEach((item) => {
                lstassignoption.push(item);
            });
            
            lstassignoption.sort((a, b) => a.Name.localeCompare(b.Name));
            setAssignUsers(lstassignoption);
        }
        }
        else if(type=="MapUser"){
            var filtervalue =  assignUsers.filter(x=>x.Id==Id);
            if(filtervalue != null){

                var lstassignoption=[];
                lstassignoption = assignUsers.filter(x=>x.Id!=Id);
                lstassignoption = lstassignoption.sort(x=>x.Name);
                lstassignoption.sort((a, b) => b.Name.localeCompare(a.Name));
                setAssignUsers(lstassignoption);


            var lstusers=[];
            users.forEach((item) => {
                lstusers.push(item);
            });
            filtervalue.forEach((item) => {
                lstusers.push(item);
            });
           // lstusers = lstusers.sort(x=>x.Name);
            lstusers.sort((a, b) => a.Name.localeCompare(b.Name));
            setUsers(lstusers);
            }
        }

    }

    const SaveProjectUserMapping = async()=>{
        setloader(true);
       var projectId =  lstProjects[Index].Id
        const data = await ApiRequest(ApiEndpoints.Entity.ProjectUserMapping(projectId), ApiEndpointMethod.Post, assignUsers, navigate);
        if(data != null){
          toast.success("Information stored successfully", {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    });
                                    var indexsvalue =Index;
           await fetchProjectList();
           await setIndex(indexsvalue);
            // setUsers(data.Item1)
            // setAssignUsers(data.Item2);
        }
        
    }
//     const move = (source, destination, droppableSource, droppableDestination) => {
//         const sourceClone = Array.from(source);
//         const destClone = Array.from(destination);
//         const [removed] = sourceClone.splice(droppableSource.index, 1);
    
//         destClone.splice(droppableDestination.index, 0, removed);
    
//         const result = {};
//         result[droppableSource.droppableId] = sourceClone;
//         result[droppableDestination.droppableId] = destClone;
    
//         return result;
//     };

//     const reorder = (list, startIndex, endIndex) => {
//         const result = Array.from(list);
//         const [removed] = result.splice(startIndex, 1);
//         result.splice(endIndex, 0, removed);
    
//         return result;
//     };

//     // onDragEnd handler to update state when an item is dropped
//   const onDragEnd = (result) => {
//     debugger;
//     alert('s')
//     const { source, destination } = result;

//     // If dropped outside the list, do nothing
//     if (!destination) {
//       return;
//     }

//     // If the item is dropped in the same list (source and destination are the same)
//     if (source.droppableId === destination.droppableId) {
//       // Reorder within the same list
//       const sourceList = source.droppableId === 'droppable1' ? users : assignUsers;
//       const reorderedList = Array.from(sourceList);
//       const [movedItem] = reorderedList.splice(source.index, 1);
//       reorderedList.splice(destination.index, 0, movedItem);

//       // Update the state
//       if (source.droppableId === 'droppable1') {
//         setUsers(reorderedList);
//       } else {
//         setAssignUsers(reorderedList);
//       }
//     } else {
//       // Move item from one list to another
//       const sourceList = source.droppableId === 'droppable1' ? users : assignUsers;
//       const destinationList = destination.droppableId === 'droppable1' ? users : assignUsers;

//       const [movedItem] = sourceList.splice(source.index, 1);
//       destinationList.splice(destination.index, 0, movedItem);

//       // Update the state
//       if (source.droppableId === 'droppable1') {
//         setUsers([...sourceList]);
//       } else {
//         setAssignUsers([...sourceList]);
//       }

//       if (destination.droppableId === 'droppable1') {
//         setUsers([...destinationList]);
//       } else {
//         setAssignUsers([...destinationList]);
//       }
//     }
//   };

    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="row">
                            <div className="col-lg-4 border-end border-lite">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0">Project Users</h5>
                                    <input className="form-control" placeholder="search..."
                                    onChange={handleChanges}  onKeyDown={handleKeyPress} value={search} 
                                     type="search" style={{ width: '180px' }} />
                                </div>
                                <div className="list-group list-group-start">
                                    {lstProjects?.map((proj,ind) => (
                                    <div onClick={()=>{setIndex(ind); setprojectName(proj.Name); FetchProjectUserMapping(proj.Id)}} className={`list-group-item d-flex justify-content-between ${ind  === Index ? 'active' : ''}`}>
                                        <p className="mb-0">{proj.Name}</p>
                                        <div className="text-nowrap">
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">{proj.UserCount} Users</span>
                                            <a className="text-primary" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                        </div>
                                    </div>
                                      ))}
                                    {/* <div className="list-group-item d-flex justify-content-between align-items-center">
                                        <p className="mb-0">Jonas Webform</p>
                                        <div>
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">5 Users</span>
                                            <a className="text-primary" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex justify-content-between align-items-center">
                                        <p className="mb-0">Amalga</p>
                                        <div>
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">2 Users</span>
                                            <a className="text-primary" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            <div className="col-lg-8">
                                {Index==-1 &&(
                                <div className="row">

                                </div>
                                   )}
                                    {Index>-1 &&(
                                <div className="row">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0 text-muted">{projectName}</h5>
                                    <button type="button" className="btn btn-sm btn-info"  onClick={() => SaveProjectUserMapping()}>
                                        <i className="fas fa-check me-2"></i>Save
                                    </button>
                                </div>

                                <div className="mb-2 text-muted" style={{display:"none"}}>
                                    <i className="fas fa-info-circle me-1 text-primary fs-f8"></i>
                                    Drag and drop users to assign them to projects
                                </div>

                                <div className="row">
                                <div className="col-lg-6">
                                        <div className="card rounded-0">
                                            <div className="card-header">All Users</div>
                                            <div className="card-body p-0">
                                                <input type="text" className="form-control" name="searchalluser" 
                                                onChange={(e) =>
                                                    setsearchalluser(
                                                      e.target.value
                                                    )
                                                  }
                                                 placeholder="Search"/>
                                                <ul className="draggable-list">
                                                    {filteredUsers.map((user) => (
                                                        <li value={user.Id}>
                                                           <label style={{width:"90%"}}>{user.Name}</label>
                                                           <i className="fas fa-arrow-circle-right" style={{cursor:"pointer"}} onClick={()=>{moveValue(user.Id,'User')}} ></i>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="card rounded-0">
                                            <div className="card-header">Assigned Users</div>
                                            <div className="card-body p-0">
                                            <input type="text" className="form-control" name="searchalluser" 
                                                onChange={(e) =>
                                                    setsearchassigneduser(
                                                      e.target.value
                                                    )
                                                  }
                                                 placeholder="Search"/>
                                                <ul className="draggable-list">
                                                    {filteredAssignedUsers.map((user, index) => (
                                                        <li className="d-flex justify-content-between align-items-center" value={user.Id}>
                                                          <i className="fas fa-arrow-circle-left" style={{cursor:"pointer"}} onClick={()=>{moveValue(user.Id,'MapUser')}} ></i>
                                                           <label style={{width:"90%"}}>{user.Name}</label>
                                                            {/* <a className="text-danger fs-f8" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                                <i className="fas fa-trash-alt"></i>
                                                            </a> */}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                {/* <DragDropContext onDragEnd={onDragEnd}>
                                 <Droppable droppableId="droppable">
                                 {(provided, snapshot) => (
                                    <div className="col-lg-6">
                                        <div className="card rounded-0">
                                            <div className="card-header">Users</div>
                                            <div className="card-body p-0">
                                                <ul className="draggable-list">
                                                    {users.map((user,inx) => (
                                                        <Draggable
                                                         key={user.Id}
                                                         draggableId={user.Id}
                                                         index={inx}>
                                                        <li>{user.Name}</li>
                                                        </Draggable>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                     )}
                                    </Droppable>
                                    <Droppable droppableId="droppable2">
                                    {(provided, snapshot) => (
                                    <div className="col-lg-6">
                                        <div className="card rounded-0">
                                            <div className="card-header">Project Users</div>
                                            <div className="card-body p-0">
                                                <ul className="draggable-list">
                                                    {assignUsers.map((user, inx) => (
                                                        <Draggable
                                                         key={user.Id}
                                                         draggableId={user.Id}
                                                         index={inx}>
                                                        <li className="d-flex justify-content-between align-items-center">
                                                            {user.Name}
                                                            <div>
                                                                {(inx === 0) && <a className="text-danger fs-f8" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                                    <i className="fas fa-trash-alt"></i></a>}
                                                                {(inx === 1) && <button className="btn btn-xs btn-outline-info">Mark as Inactive</button>}
                                                                {(inx === 2) && <span className="text-muted fs-f8 fst-italic">InActive</span>}
                                                            </div>
                                                        </li>
                                                        </Draggable>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                     )}
                                    </Droppable>
                                    </DragDropContext> */}

                                </div>
                                </div>
                                  )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
            {loader && (
                <Loader/>
            )}
        </>
    )
}

export default ProjectUsers;